<div class="text-center h-100 align-items-center row" [class.set-css]='setCss'>
  <div class="col align-self-center">
    <mat-spinner style="display: inline-block;"></mat-spinner>
  </div>
</div>
